import(/* webpackMode: "eager" */ "/app/src/app/nearby-centres/page.tsx");
